export default "__VITE_ASSET__Dw6Z47tB__"